document.addEventListener('DOMContentLoaded', function () {
  console.log('Cart page quantity fix loaded');

  if (!window.location.pathname.includes('/cart')) {
    return;
  }

  console.log('Initializing cart page quantity fix');

  function updateCartCounts(count) {
    const cartCounts = document.querySelectorAll('.sf-cart-count');
    cartCounts.forEach(element => {
      element.textContent = count;
      console.log('Updated sf-cart-count to:', count);
    });
  }

  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart');
      return await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  async function refreshCartCount() {
    const cart = await getCartData();
    if (cart) {
      updateCartCounts(cart.item_count);
      return cart.item_count;
    }
    return null;
  }

  refreshCartCount();

  const qtyForms = document.querySelectorAll('form[action="/cart"]');
  const qtyInputs = document.querySelectorAll('input[name^="updates"]');
  const qtyAdjustButtons = document.querySelectorAll(
    '.quantity__button, ' +
    '.js-qty__adjust, ' +
    '[data-action="decrease-quantity"], ' +
    '[data-action="increase-quantity"], ' +
    '.quantity-increment, ' +
    '.quantity-decrement'
  );

  console.log(`Found ${qtyForms.length} cart forms, ${qtyInputs.length} quantity inputs, ${qtyAdjustButtons.length} adjust buttons`);

  qtyAdjustButtons.forEach(button => {
    const originalOnClick = button.onclick;

    button.onclick = function (e) {
      if (originalOnClick) {
        originalOnClick.call(this, e);
      }

      console.log('Quantity button clicked, refreshing cart count in 500ms');
      setTimeout(refreshCartCount, 500);
    };
  });

  qtyInputs.forEach(input => {

    const originalOnChange = input.onchange;

    input.onchange = function (e) {

      if (originalOnChange) {
        originalOnChange.call(this, e);
      }


      console.log('Quantity input changed, refreshing cart count in 500ms');
      setTimeout(refreshCartCount, 500);
    };
  });


  qtyForms.forEach(form => {
    const originalSubmit = form.onsubmit;

    form.onsubmit = function (e) {

      if (originalSubmit) {
        originalSubmit.call(this, e);
      }


      console.log('Cart form submitted, refreshing cart count in 1000ms');
      setTimeout(refreshCartCount, 1000);
    };
  });


  const cartItemContainer = document.querySelector('.cart__items, .cart-items, .cart__body, .cart-item-list');

  if (cartItemContainer) {
    console.log('Setting up mutation observer for cart container');

    const observer = new MutationObserver(mutations => {

      const shouldUpdate = mutations.some(mutation => {

        if (mutation.type === 'childList') {
          return true;
        }


        if (mutation.type === 'attributes' &&
          (mutation.target.matches('input[name^="updates"]') ||
            mutation.target.closest('.quantity-wrapper'))) {
          return true;
        }

        return false;
      });

      if (shouldUpdate) {
        console.log('Cart DOM changed, refreshing cart count in 500ms');
        setTimeout(refreshCartCount, 500);
      }
    });

    observer.observe(cartItemContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'data-quantity']
    });
  }


  const refreshInterval = setInterval(refreshCartCount, 5000);


  window.addEventListener('beforeunload', function () {
    clearInterval(refreshInterval);
  });

  console.log('Cart page quantity fix initialization complete');
}); 